export default function CTASection() {
  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20horizontal%20panoramic%20shot%20of%20carefully%20curated%20fashion%20and%20lifestyle%20products%20in%20warm%20terracotta%20olive%20and%20cream%20tones%2C%20arranged%20elegantly%20on%20a%20long%20wooden%20table%2C%20soft%20golden%20hour%20sunlight%2C%20luxurious%20editorial%20aesthetic&width=1800&height=700&seq=cta-bg-v3-2026x&orientation=landscape"
          alt="Mulebuy Spreadsheet product showcase"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/55"></div>
      </div>

      <div className="relative z-10 mx-auto max-w-[1440px] px-4 md:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-10">
          <div className="max-w-[520px]">
            <h2 className="text-white text-3xl md:text-[3.25rem] font-heading font-bold leading-[1.1] mb-4">
              smart buying<br />starts here
            </h2>
            <p className="text-white/80 text-base md:text-lg leading-relaxed">
              Access curated comparisons, guides, and breakdowns designed to help you understand how the mulebuy spreadsheet ecosystem works.
            </p>
          </div>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-7 py-4 rounded-full bg-background-50 text-foreground-950 text-base font-semibold cursor-pointer hover:bg-white hover:scale-[1.02] transition-all whitespace-nowrap flex-shrink-0"
          >
            Buy It Now
            <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}